import { baseApi } from '@app/store/index.api';

import {
  ICopyPolicyQuery,
  ICreatePolicyQuery,
  ICreateRuleQuery,
  IDeletePolicyQuery,
  IDeleteRuleQuery,
  IPolicyResponse,
  IPolicySettingsResponse,
  IRuleResponse,
  IUpdatePolicyQuery,
  IUpdateRuleQuery,
} from '../model/types';

const policyApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getPolicies: builder.query<IPolicyResponse, string | void>({
      query: query => ({
        url: query ? `/router/policy?${query}` : '/router/policy',
      }),
      providesTags: ['Policies'],
    }),
    createPolicy: builder.mutation<IPolicyResponse, ICreatePolicyQuery>({
      query: body => ({
        url: '/router/policy',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Policies'],
    }),
    updatePolicy: builder.mutation<IPolicyResponse, IUpdatePolicyQuery>({
      query: ({ id, ...body }) => ({
        url: `/router/policy/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Policies'],
    }),
    deletePolicy: builder.mutation<{ id: string }, IDeletePolicyQuery>({
      query: ({ id }) => ({
        url: `/router/policy/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Policies'],
    }),
    copyPolicy: builder.mutation<IPolicyResponse, ICopyPolicyQuery>({
      query: ({ id }) => ({
        url: `/router/policy/${id}/copy`,
        method: 'POST',
      }),
      invalidatesTags: ['Policies'],
    }),

    getRules: builder.query<IRuleResponse, string | void>({
      query: query => ({
        url: query ? `/router/rule?${query}` : '/router/rule',
      }),
      providesTags: ['PolicyRules'],
    }),
    createRule: builder.mutation<IRuleResponse, ICreateRuleQuery>({
      query: body => ({
        url: '/router/rule',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PolicyRules'],
    }),
    updateRule: builder.mutation<IRuleResponse, IUpdateRuleQuery>({
      query: ({ id, ...body }) => ({
        url: `/router/rule/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['PolicyRules'],
    }),
    updateRulePriority: builder.mutation<IRuleResponse, IUpdateRuleQuery>({
      query: ({ id, ...body }) => ({
        url: `/router/rule/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [],
    }),
    deleteRule: builder.mutation<{ id: string }, IDeleteRuleQuery>({
      query: ({ id }) => ({
        url: `/router/rule/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PolicyRules'],
    }),

    getPolicySettings: builder.query<IPolicySettingsResponse, void>({
      query: () => ({
        url: '/router/settings',
      }),
      providesTags: ['PolicySettings'],
    }),
  }),
});

export const {
  useGetPoliciesQuery,
  useCreatePolicyMutation,
  useUpdatePolicyMutation,
  useDeletePolicyMutation,
  useCopyPolicyMutation,
  useGetRulesQuery,
  useCreateRuleMutation,
  useUpdateRuleMutation,
  useUpdateRulePriorityMutation,
  useDeleteRuleMutation,
  useGetPolicySettingsQuery,
} = policyApi;
